import * as Yup from 'yup'

import { urlValidation, urlAllowingPlaceholders } from '../../../../../features/validations/other'
import { tikTokAdCTAValidation, tikTokAdTextValidation } from '../../validation'

import { FILE_ID } from '../../../../ReusableFormFields/AdFileUpload/fields'
import {
  BRAND_SAFETY_POSTBID_PARTNER,
  BRAND_SAFETY_VAST_URL,
  IAS,
  NAME,
  VIEWABILITY_POSTBID_PARTNER,
  VIEWABILITY_VAST_URL,
  VIDEO_THUMBNAIL_URL,
  IDENTITY
} from './fields'
import { AD_TEXT, CALL_TO_ACTION, LANDING_PAGE_URL } from '../../fields'

// Add a custom method to Yup string schema for validating URLs with placeholders
Yup.addMethod(Yup.string, 'placeholderUrl', function (message) {
  return this.test('placeholderUrl', message, function (value) {
    if (!value) return true
    return urlAllowingPlaceholders(value) || this.createError({ message })
  })
})

export const validationSchema = Yup.object({
  [NAME]: Yup.string().required('Name required').max(512, 'Name should have maximum 512 characters'),
  [IDENTITY]: Yup.object({
    external_id: Yup.string().required('Identity external_id is required'),
    name: Yup.string().required('Identity name is required')
  }).required('Please select identity'),
  [LANDING_PAGE_URL]: urlValidation,
  [AD_TEXT]: tikTokAdTextValidation,
  [CALL_TO_ACTION]: tikTokAdCTAValidation,
  [FILE_ID]: Yup.string().required('Please select a video file'),
  [VIDEO_THUMBNAIL_URL]: Yup.string().required('Please select a video thumbnail'),
  [VIEWABILITY_VAST_URL]: Yup.string().when(VIEWABILITY_POSTBID_PARTNER, {
    is: IAS,
    then: () =>
      Yup.string()
        .transform(value => value?.trim())
        .placeholderUrl('Please enter a valid URL')
        .required('Viewability VAST URL is required when IAS is selected'),
    otherwise: () => Yup.string()
  }),
  [BRAND_SAFETY_VAST_URL]: Yup.string().when(BRAND_SAFETY_POSTBID_PARTNER, {
    is: IAS,
    then: () =>
      Yup.string()
        .transform(value => value?.trim())
        .placeholderUrl('Please enter a valid URL')
        .required('Brand Safety VAST URL is required when IAS is selected'),
    otherwise: () => Yup.string()
  })
})
